import * as React from 'react';
import { AdminState } from '../admin/admin.types';
import { PosState, PosRegisterRequest, PosRegistrationResponse } from './Types';
import { CreditCardType } from '../payments/Types';
import { NONE, CREDIT_CARD_LENGTH, AMEX_LENGTH } from '../payments/Constants';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import {
  validateCreditCardNumber,
  isValidName,
  isValidAmount,
  isValidBusinessName
} from '../util/Validation';
import * as creditcardutils from 'creditcardutils';
import { addZeroCentIfNecessary } from '../util/AmountUtil';
import RaisedButton from 'material-ui/RaisedButton';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import { isAuthTokenExpired } from '../commons/AuthTokenValidator';
import { renderCreditCardIcon, parseCreditCardType } from '../creditcard/CreditCardIconHelper';
import CommonFeatures from '../commons/CommonFeatures';
import { Link } from 'react-router-dom';
import SelectField from 'material-ui/SelectField';
import { CURRENCY_FIELD_LABEL, currencyList } from '../billing/billing.const';
import MenuItem from 'material-ui/MenuItem';
import {
  Currency, PayerInfo, PayMethodsInfo, PayersState, PayMethodsState
} from '../billing/billing.types';
import { BusinessState } from '../business/business.types';
import { ProvincialTaxes, ProvincialTax } from '../geo/geo.types';
import AutoComplete from 'material-ui/AutoComplete';
import { Member, MembersState, MembersResponseData } from '../members/members.types';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';
import { PaymentMethodType } from './Types';
import './pos.css';
import { M3BASIC } from '../business/business.constants';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import * as validator from 'validator';
import { isPosCreate, isPosFull, isPosUpdate } from '../util/permission.util';
import { AuthState } from '../auth/auth.types';

const paperStyle = {
  height: '100%',
  width: '100%'
};

type Props = {
  readonly authState: AuthState
  readonly adminState: AdminState
  readonly posState: PosState
  readonly toAdminDashboard: () => void
  readonly toPosSaleResult: () => void
  readonly registerPos: (posRegisterRequest: PosRegisterRequest) => Promise<Response>
  readonly businessState: BusinessState
  readonly membersState: MembersState
  readonly payersState: PayersState
  readonly payMethodsState: PayMethodsState
  readonly getMembers: () => Promise<MembersResponseData>
  readonly getPayers: () => Promise<MembersResponseData>
  readonly getPayMethods: (payerId: number) => Promise<MembersResponseData>
  readonly getPredefinedItems: () => Promise<Response>,
  readonly createPredefinedItem: (req: PosRegisterRequest) => Promise<Response>,
  readonly updatePredefinedItem: (req: PosRegisterRequest) => Promise<Response>,
  readonly deletePredefinedItem: (id: number) => Promise<Response>
};

type States = {
  readonly creditNumber: string
  readonly creditcardType: CreditCardType
  readonly creditNumberError: string
  readonly expiryMonth: string
  readonly expiryYear: string
  readonly expiryError: string
  readonly cardHolderName: string
  readonly cardHolderNameError: string
  readonly cvc: string
  readonly amount: string
  readonly amountError: string
  readonly description: string
  readonly loading: boolean
  readonly currency: Currency
  readonly email?: string
  readonly tax: string
  readonly taxPercentage: number
  readonly taxError: string
  readonly total: number
  readonly dataSourcePayer: string[]
  readonly dataSourceMember: string[]
  readonly searchTextPayer: string
  readonly searchTextMember: string
  readonly selectedMember?: Member
  readonly membersLoading: boolean
  readonly payersLoading: boolean
  readonly payMethodsLoading: boolean
  readonly paymentMethodType: PaymentMethodType
  readonly openAddPredefinedItemModal: boolean
  readonly predefinedItemAmount: string
  readonly predefinedItemAmountError: string
  readonly predefinedItemDescription: string
  readonly predefinedItemTax: string
  readonly predefinedItemTotal: number
  readonly predefinedItemCurrency: Currency
  readonly predefinedItemTaxError: string
  readonly predefinedItemName: string
  readonly predefinedItemNameError: string
  readonly emailError: string
  readonly predefinedItemLoading: boolean
  readonly selectedPredefinedItem?: PosRegistrationResponse
  readonly editingPredefinedItem: boolean
  readonly transactionError: string
  readonly openTransactionFailModal: boolean
  readonly predefinedItemDescriptionError: string
  readonly selectedPayer: PayerInfo
  readonly selectedPayMethod: PayMethodsInfo
  readonly relatedMembers: Member[]
  readonly relatedPayers: PayerInfo[]
  readonly paymethods: PayMethodsInfo[]
};

const MAX_LENGTH = 250;

class PosSaleComponent extends React.Component<Props, States> {

  constructor(props: Props) {
    super(props);

    this.state = {
      creditNumber: '',
      creditcardType: NONE,
      expiryError: '',
      expiryMonth: '',
      expiryYear: '',
      creditNumberError: '',
      cardHolderName: '',
      cardHolderNameError: '',
      cvc: '',
      amount: '0.00',
      amountError: '',
      description: '',
      loading: false,
      currency: 'CAD',
      tax: '0.00',
      taxPercentage: this.getDefaultTax(),
      taxError: '',
      total: 0,
      dataSourcePayer: this.mapPayerName(props),
      dataSourceMember: this.mapPayerName(props),
      searchTextPayer: '',
      searchTextMember: '',
      membersLoading: true,
      payersLoading: true,
      payMethodsLoading: true,
      paymentMethodType: props.businessState.business && props.businessState.business.servicePackage === M3BASIC ?
        'CASH' :
        'CREDITCARD',
      openAddPredefinedItemModal: false,
      predefinedItemAmount: '0.00',
      predefinedItemAmountError: '',
      predefinedItemDescription: '',
      predefinedItemTax: '0.00',
      predefinedItemTotal: 0,
      predefinedItemCurrency: 'CAD',
      predefinedItemTaxError: '',
      predefinedItemName: '',
      predefinedItemNameError: '',
      emailError: '',
      predefinedItemLoading: false,
      editingPredefinedItem: false,
      transactionError: '',
      openTransactionFailModal: false,
      predefinedItemDescriptionError: '',
      selectedPayer: undefined,
      selectedPayMethod: undefined,
      relatedMembers: [],
      relatedPayers: [],
      paymethods: []
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (
      this.props !== nextProps &&
      this.props.posState.sale &&
      nextProps.posState.sale &&
      this.props.posState.sale.receiptId !== nextProps.posState.sale.receiptId
    ) {
      // responseCoee bigger than 30 is error. Approved is '027'.
      if (nextProps.posState.statusCode === 200 && parseInt(nextProps.posState.sale.responseCode, 10) > 30) {
        return this.setState({
          transactionError: 'Transaction is DECLINED',
          openTransactionFailModal: true,
          loading: false
        });
      } else {
        return this.setState(
          {
            transactionError: '',
            openTransactionFailModal: false,
            loading: false
          },
          nextProps.toPosSaleResult
        );
      }
    } else if (this.props !== nextProps && !nextProps.posState.sale) {
      if (nextProps.posState.statusCode === 417) {
        return this.setState({
          transactionError: 'Something went wrong. Please check Credit Card inputs again.',
          openTransactionFailModal: true,
          loading: false
        });
      } else if (nextProps.posState.statusCode === 406) {
        return this.setState({
          transactionError: 'Creditcard validation failed. Please check inputs again.',
          openTransactionFailModal: true,
          loading: false
        });
      } else if (nextProps.posState.statusCode === 400) {
        return this.setState({
          transactionError: 'Transaction request failed. Please check your inputs again.',
          openTransactionFailModal: true,
          loading: false
        });
      }
    } else if (this.props.payersState !== nextProps.payersState) {
      this.setState({ dataSourcePayer: this.mapPayerName(nextProps) });
    } else if (this.props.membersState !== nextProps.membersState) {
      this.setState({ dataSourceMember: this.mapMemberName(nextProps) });
    }
  }

  componentWillUnmount() {
    this.setState(
      {
        loading: false,
        membersLoading: true,
        openAddPredefinedItemModal: false,
        predefinedItemLoading: false,
        transactionError: '',
        openTransactionFailModal: false,
        predefinedItemDescriptionError: ''
      }
    );
  }

  componentDidMount() {
    if (this.state.payersLoading) {
      this.props.getPayers().then(
        response => {
          switch (this.props.payersState.statusCode) {
            case 200: return this.setState({ payersLoading: false });
            default:
          }
        }
      );
    }
    if (this.state.payMethodsLoading && this.state.selectedPayer) {
      this.props.getPayMethods(this.state.selectedPayer.id).then(
        response => {
          switch (this.props.payMethodsState.statusCode) {
            case 200: return this.setState({ payMethodsLoading: false });
            default:
          }
        }
      );
    }
    if (this.state.membersLoading) {
      this.props.getMembers().then(
        response => {
          switch (this.props.membersState.statusCode) {
            case 200: return this.setState({ membersLoading: false });
            default:
          }
        }
      );
    }

    this.props.getPredefinedItems();
  }

  render() {
    const {
      cardHolderName,
      cardHolderNameError,
      creditNumber,
      creditNumberError,
      expiryMonth,
      expiryYear,
      expiryError,
      cvc,
      amount,
      amountError,
      description,
      creditcardType,
      email,
      tax,
      total,
      taxError
    } = this.state;

    return (
      <CommonFeatures
        authState={this.props.authState}
        businessState={this.props.businessState}
      >
        <div className="page-header-row row mt-2 mb-2">
          <div className="col-auto">
            <h3>P.O.S. Sale</h3>
          </div>
        </div>
        <div className="row mt-2 animated fadeIn">
          <div className="col-8">
            <Paper style={paperStyle} zDepth={3}>
              <div className="row pl-3 pr-3">
                <div className="col-6">
                  <SelectField
                    className="material-input-required-red"
                    fullWidth={true}
                    floatingLabelText="Payment Type"
                    value={this.state.paymentMethodType}
                    onChange={this.onPaymentTypeChange}
                  >
                    {
                      this.props.businessState.business && this.props.businessState.business.servicePackage
                        === M3BASIC ?
                        [
                          <MenuItem key={0} value={'CASH'} primaryText={'Cash'} />
                        ] :
                        [
                          <MenuItem
                            key={0}
                            value={'CREDITCARD'}
                            primaryText={'C.C/ Visa/Mastercard Debit'}
                          />,
                          <MenuItem key={1} value={'CASH'} primaryText={'Cash'} />
                        ]
                    }
                  </SelectField>
                </div>
              </div>
              <div className="row col-12">
                <div className="col col-6">
                  <div className="col-12">
                    <TextField
                      className="material-input-required-red"
                      hintText="Amount"
                      floatingLabelText="Amount"
                      value={amount}
                      errorText={amountError}
                      onChange={this.handleAmountChange}
                      fullWidth={true}
                      onFocus={() => this.setState((prevState: States, props: Props) =>
                        ({ amount: prevState.amount === '0.00' ? '' : prevState.amount })
                      )}
                      onBlur={() => this.setState((prevState: States, props: Props) =>
                        ({ amount: addZeroCentIfNecessary(prevState.amount, prevState.amountError) })
                      )}
                    />
                  </div>
                  <div className="col-12">
                    <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                      <SelectField
                        className="material-input-required-red"
                        fullWidth={true}
                        floatingLabelText={CURRENCY_FIELD_LABEL}
                        value={this.state.currency}
                        onChange={this.onCurrencyChange}
                      >
                        {
                          currencyList.map((currency, index) => {
                            return <MenuItem key={index} value={currency} primaryText={currency} />;
                          })
                        }
                      </SelectField>
                    </div>
                  </div>
                  <div className="col-12">
                    <TextField
                      className="material-input-required-red"
                      hintText="Tax"
                      floatingLabelText="Tax"
                      value={tax}
                      onChange={this.handleTaxChange}
                      fullWidth={true}
                      errorText={taxError}
                      onFocus={() => this.setState((prevState: States, props: Props) =>
                        ({ tax: prevState.tax === '0.00' ? '' : prevState.tax })
                      )}
                      onBlur={() => this.setState((prevState: States, props: Props) =>
                        ({ tax: addZeroCentIfNecessary(prevState.tax, prevState.taxError) })
                      )}
                    />
                  </div>
                  <div className="col-12">
                    <TextField
                      hintText="Total"
                      floatingLabelText="Total"
                      value={total}
                      disabled={true}
                      fullWidth={true}
                    />
                  </div>
                </div>
                {
                  this.state.paymentMethodType === 'CREDITCARD' ?
                    <div className="col col-6">
                      <div className="col-12">
                        <TextField
                          className="material-input-required-red"
                          hintText="The holder name on the front of a credit card."
                          floatingLabelText="Name on card"
                          value={cardHolderName}
                          onChange={this.handleCardHolderNameChange}
                          errorText={cardHolderNameError}
                          fullWidth={true}
                        />
                      </div>
                      <div className="col-12">
                        {renderCreditCardIcon(creditcardType)}
                        <TextField
                          className="material-input-required-red"
                          hintText="16 digits on the front"
                          floatingLabelText="Credit Card Number"
                          value={creditNumber}
                          onChange={this.handleCreditNumberChange}
                          errorText={creditNumberError}
                          fullWidth={true}
                        />
                      </div>
                      <div className="row col-12">
                        <div className="col-6">
                          <TextField
                            className="material-input-required-red"
                            hintText="MM (e.g. 01, 02)"
                            floatingLabelText="Expiry Month"
                            value={expiryMonth}
                            onChange={this.handleExpiryMonthChange}
                            errorText={expiryError}
                            fullWidth={true}
                          />
                        </div>
                        <div className="col-6">
                          <TextField
                            className="material-input-required-red"
                            hintText="YY (e.g. 2019 = 19)"
                            floatingLabelText="Expiry Year"
                            value={expiryYear}
                            onChange={this.handleExpiryYearChange}
                            errorText={expiryError}
                            fullWidth={true}
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <TextField
                          className={this.state.selectedPayMethod ? '' : 'material-input-required-red'}
                          hintText="On the back"
                          floatingLabelText="CVC"
                          value={cvc}
                          onChange={this.handleCvcChange}
                          fullWidth={true}
                        />
                      </div>
                    </div> :
                    undefined
                }
              </div>
              <div className="row pa3">
                <div className="col-12">
                  <TextField
                    fullWidth={true}
                    hintText="Email For Receipt"
                    floatingLabelText="Email"
                    value={email}
                    errorText={this.state.emailError}
                    onChange={this.handleEmailChange}
                  />
                </div>
              </div>
              <div className="row pa3">
                <div className="col-12">
                  <TextField
                    className="material-input-required-red"
                    fullWidth={true}
                    hintText="Description of the sale"
                    floatingLabelText="Description"
                    multiLine={true}
                    rows={3}
                    value={description}
                    onChange={this.handleDescriptionChange}
                  />
                </div>
              </div>
              <div className="row pa4 justify-content-end">
                <div className="col-auto">
                  {this.renderLoadingSpinnerOrSubmitButton()}
                </div>
              </div>
            </Paper>
          </div>
          <div className="col-4">
            <div className="row" style={{ height: '48%' }}>
              <div className="col-12">
                <Paper
                  style={paperStyle}
                  zDepth={3}
                >
                  <div className="row pt3 pl3 pr3">
                    <b className="col-12">
                      From Existing Data
                    </b>
                  </div>
                  <hr className="pt-3 pl-3 pr-3" />
                  <div className="row pl3 pr3">
                    <div className="col-12">
                      <AutoComplete
                        hintText="Member"
                        floatingLabelText="Member"
                        searchText={this.state.searchTextMember}
                        onUpdateInput={this.handleSearchTextMemberUpdate}
                        dataSource={this.state.dataSourceMember}
                        onNewRequest={this.handleNewRequestMember}
                        filter={AutoComplete.caseInsensitiveFilter}
                        maxSearchResults={5}
                        fullWidth={true}
                        disabled={this.state.dataSourceMember.length === 0}
                      />
                    </div>
                    <div className="col-12">
                      <SelectField
                        fullWidth={true}
                        floatingLabelText={'Payer'}
                        value={this.state.selectedPayer}
                        onChange={this.onSelectedPayerChange}
                        disabled={this.state.relatedPayers.length === 0}
                      >
                        {
                          this.state.relatedPayers.map((p: PayerInfo, index) => {
                            return <MenuItem
                              key={index}
                              value={p}
                              primaryText={p.firstName + ' ' + p.lastName + ' / ' + p.mobile1}
                            />;
                          })
                        }
                      </SelectField>
                    </div>
                    <div className="col-12">
                      {
                        this.state.paymentMethodType === 'CREDITCARD' ?
                          <SelectField
                            fullWidth={true}
                            floatingLabelText={'Payment Method'}
                            value={this.state.selectedPayMethod}
                            onChange={this.onSelectedPayMethodChange}
                            disabled={this.state.selectedPayer === undefined}
                          >
                            {
                              this.state.paymethods ?
                                this.state.paymethods.map((p: PayMethodsInfo, index) => {
                                  if (p.paymentMethodType === 'CREDITCARD') {
                                    return <MenuItem
                                      key={index}
                                      value={p}
                                      primaryText={p.cardNumber + ' - ' + p.expiryMonth + '/' + p.expiryYear}
                                    />;
                                  } else {
                                    return null;
                                  }
                                }) :
                                []
                            }

                          </SelectField>
                          : null
                      }
                    </div>
                  </div>
                </Paper>
              </div>
            </div>
            <div className="row mt3" style={{ height: '50%' }}>
              <div className="col-12">
                <Paper
                  style={paperStyle}
                  zDepth={3}
                >
                  <div className="row pt3 pl3 pr3">
                    <b className="col-10">
                      Predefined Item
                    </b>
                    <div className="col-2">
                      <FloatingActionButton
                        mini={true}
                        onClick={() => this.setState({
                          openAddPredefinedItemModal: true,
                          predefinedItemAmount: '',
                          predefinedItemAmountError: '',
                          predefinedItemName: '',
                          predefinedItemNameError: '',
                          predefinedItemTax: '',
                          predefinedItemTaxError: '',
                          predefinedItemDescription: '',
                          predefinedItemDescriptionError: '',
                          predefinedItemTotal: 0.00,
                          editingPredefinedItem: false
                        })}
                        disabled={this.notEnoughPermission()}
                      >
                        <ContentAdd />
                      </FloatingActionButton>
                    </div>
                  </div>
                  <hr className="pt-3 pl-3 pr-3" />
                  <div className="row pt3 pl3 pr3">
                    <div className="col-12">
                      <SelectField
                        fullWidth={true}
                        floatingLabelText={'Predefined Item'}
                        value={this.state.selectedPredefinedItem}
                        onChange={this.onSelectedPredefinedItemChange}
                      >
                        {
                          this.props.posState.predefinedItems ?
                            this.props.posState.predefinedItems.map((p: PosRegistrationResponse, index) => {
                              return p && <MenuItem key={index} value={p} primaryText={p.name} />;
                            }) :
                            []
                        }
                      </SelectField>
                    </div>
                  </div>
                  {
                    this.state.selectedPredefinedItem ?
                      <div className="row pt3 pl3 pr3">
                        <div className="col-4">
                          {
                            this.state.predefinedItemLoading ?
                              <RefreshIndicator
                                size={40}
                                left={0}
                                top={0}
                                status="loading"
                                style={{
                                  display: 'inline-block',
                                  position: 'relative',
                                  marginLeft: '2%',
                                  marginRight: '2%'
                                }}
                              /> :
                              <RaisedButton
                                label={'Delete'}
                                disabled={!isPosFull(this.props.authState, this.props.adminState)}
                                secondary={true}
                                fullWidth={true}
                                onClick={() => {
                                  this.setState(
                                    { predefinedItemLoading: true },
                                    () =>
                                      this.props.deletePredefinedItem(this.state.selectedPredefinedItem.id)
                                        .then(res => {
                                          switch (this.props.posState.statusCode) {
                                            case 200:
                                              this.setState(
                                                {
                                                  selectedPredefinedItem: undefined,
                                                  predefinedItemLoading: false,
                                                  amount: '0.00',
                                                  tax: '0.00',
                                                  total: 0.00,
                                                  description: ''
                                                }
                                              );
                                              break;
                                            default:
                                              break;
                                          }
                                        })
                                  );
                                }}
                              />

                          }
                        </div>
                        <div className="col-4">
                          {
                            this.state.predefinedItemLoading ?
                              <RefreshIndicator
                                size={40}
                                left={0}
                                top={0}
                                status="loading"
                                style={{
                                  display: 'inline-block',
                                  position: 'relative',
                                  marginLeft: '2%',
                                  marginRight: '2%'
                                }}
                              /> :
                              <RaisedButton
                                label="Unselect"
                                fullWidth={true}
                                onClick={() => this.setState({
                                  selectedPredefinedItem: undefined,
                                  amount: '0.00',
                                  tax: '0.00',
                                  total: 0.00,
                                  description: ''
                                })}
                              />
                          }
                        </div>
                        <div className="col-4">
                          {
                            this.state.predefinedItemLoading ?
                              <RefreshIndicator
                                size={40}
                                left={0}
                                top={0}
                                status="loading"
                                style={{
                                  display: 'inline-block',
                                  position: 'relative',
                                  marginLeft: '2%',
                                  marginRight: '2%'
                                }}
                              /> :
                              <RaisedButton
                                label="Edit"
                                disabled={
                                  !isPosUpdate(this.props.authState, this.props.adminState) &&
                                  !isPosFull(this.props.authState, this.props.adminState)
                                }
                                primary={true}
                                fullWidth={true}
                                onClick={() => {
                                  this.setState((prevState: States, props: Props) => ({
                                    openAddPredefinedItemModal: true,
                                    predefinedItemAmount: addZeroCentIfNecessary(
                                      prevState.selectedPredefinedItem.amount.toString(),
                                      prevState.predefinedItemAmountError
                                    ),
                                    predefinedItemTax: addZeroCentIfNecessary(
                                      prevState.selectedPredefinedItem.tax.toString(),
                                      prevState.predefinedItemTaxError
                                    ),
                                    predefinedItemTotal: prevState.selectedPredefinedItem.total,
                                    predefinedItemDescription: prevState.selectedPredefinedItem.description,
                                    predefinedItemCurrency: prevState.selectedPredefinedItem.currency,
                                    predefinedItemName: prevState.selectedPredefinedItem.name,
                                    editingPredefinedItem: true
                                  }));
                                }}
                              />
                          }
                        </div>
                      </div> :
                      undefined
                  }
                </Paper>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4 mb-4 animated fadeIn">
          <div className="col-8">
            <div className="alert alert-secondary" role="alert">
              By proceeding with payment, you agree to our&nbsp;
              {this.renderServiceAgreementLink('Service Agreement')} and&nbsp;
              {this.renderServiceAgreementLink('Privacy Policy')}
            </div>
          </div>
        </div>
        {this.renderAddPredefinedItemModal()}
        {this.renderTransactionErrorModal()}
      </CommonFeatures>
    );
  }

  private renderTransactionErrorModal = (): JSX.Element => {
    if (this.state.transactionError) {
      return (
        <Dialog
          title="Transaction Failed"
          actions={[
            this.renderOkayButton()
          ]}
          modal={true}
          open={this.state.openTransactionFailModal}
          onRequestClose={() => this.setState({ openTransactionFailModal: false })}
          repositionOnUpdate={false}
          autoScrollBodyContent={true}
        >
          <div className="red">
            {this.state.transactionError}
          </div>
        </Dialog>
      );
    } else {
      return null;
    }
  }

  private renderOkayButton = (): JSX.Element => {
    return (
      <FlatButton
        label="Okay"
        primary={true}
        onClick={() => this.setState({ openTransactionFailModal: false })}
      />
    );
  }

  private renderAddPredefinedItemModal = (): JSX.Element => {
    return (
      <Dialog
        title="Create Predefined Item"
        actions={[
          this.renderPredefinedCancelButton(),
          this.renderPredefinedSubmitButton()
        ]}
        modal={true}
        open={this.state.openAddPredefinedItemModal}
        onRequestClose={() => this.setState({ openAddPredefinedItemModal: false })}
        repositionOnUpdate={false}
        style={{ paddingTop: '0%' }}
        autoScrollBodyContent={true}
      >
        <div className="row pa3">
          <div className="col-6">
            <TextField
              className="material-input-required-red"
              hintText="Item Name"
              floatingLabelText="Item Name"
              value={this.state.predefinedItemName}
              errorText={this.state.predefinedItemNameError}
              onChange={this.handlePredefinedItemNameChange}
              fullWidth={true}
            />
          </div>
        </div>
        <div className="row pa3">
          <div className="col-3">
            <TextField
              className="material-input-required-red"
              hintText="Amount"
              floatingLabelText="Amount"
              value={this.state.predefinedItemAmount}
              errorText={this.state.predefinedItemAmountError}
              onChange={this.handlePredefinedItemAmountChange}
              fullWidth={true}
              onFocus={() => this.setState((prevState: States, props: Props) =>
                ({
                  predefinedItemAmount: prevState.predefinedItemAmount === '0.00' ?
                    '' :
                    prevState.predefinedItemAmount
                })
              )}
              onBlur={() => this.setState((prevState: States, props: Props) =>
                ({
                  predefinedItemAmount:
                    addZeroCentIfNecessary(prevState.predefinedItemAmount, prevState.predefinedItemAmountError)
                })
              )}
            />
          </div>
          <div className="col-3">
            <div className="input-group mb-2 mr-sm-2 mb-sm-0">
              <SelectField
                className="material-input-required-red"
                fullWidth={true}
                floatingLabelText={CURRENCY_FIELD_LABEL}
                value={this.state.predefinedItemCurrency}
                onChange={this.onPredefinedItemCurrencyChange}
              >
                {
                  currencyList.map((currency, index) => {
                    return <MenuItem key={index} value={currency} primaryText={currency} />;
                  })
                }
              </SelectField>
            </div>
          </div>
          <div className="col-3">
            <TextField
              className="material-input-required-red"
              hintText="Tax"
              floatingLabelText="Tax"
              value={this.state.predefinedItemTax}
              onChange={this.handlePredefinedItemTaxChange}
              fullWidth={true}
              errorText={this.state.predefinedItemTaxError}
              onFocus={() => this.setState((prevState: States, props: Props) =>
                ({ predefinedItemTax: prevState.predefinedItemTax === '0.00' ? '' : prevState.predefinedItemTax })
              )}
              onBlur={() => this.setState((prevState: States, props: Props) =>
                ({
                  predefinedItemTax:
                    addZeroCentIfNecessary(prevState.predefinedItemTax, prevState.predefinedItemTaxError)
                })
              )}
            />
          </div>
          <div className="col-3">
            <TextField
              hintText="Total"
              floatingLabelText="Total"
              value={this.state.predefinedItemTotal}
              disabled={true}
              fullWidth={true}
            />
          </div>
        </div>
        <div className="row pa3">
          <div className="col-12">
            <TextField
              className="material-input-required-red"
              fullWidth={true}
              hintText="Description of the sale"
              floatingLabelText="Description"
              multiLine={true}
              rows={2}
              value={this.state.predefinedItemDescription}
              errorText={this.state.predefinedItemDescriptionError}
              onChange={this.handlePredefinedItemDescriptionChange}
            />
          </div>
        </div>
      </Dialog>
    );
  }

  private renderPredefinedCancelButton = (): JSX.Element => {
    return (
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={() => this.setState({ openAddPredefinedItemModal: false })}
      />
    );
  }

  private renderPredefinedSubmitButton = (): JSX.Element => {
    if (this.state.predefinedItemLoading) {
      return (
        <RefreshIndicator
          size={40}
          left={0}
          top={0}
          status="loading"
          style={{
            display: 'inline-block',
            position: 'relative',
            marginLeft: '2%',
            marginRight: '2%'
          }}
        />
      );
    } else {
      return (
        <FlatButton
          label={this.state.editingPredefinedItem ? 'UPDATE' : 'SUBMIT'}
          disabled={this.predefinedItemErrorExists() || this.predefinedItemNotComplete()}
          primary={true}
          onClick={() => {
            this.setState(
              { predefinedItemLoading: true },
              () => {
                if (this.state.editingPredefinedItem) {
                  this.props.updatePredefinedItem(
                    {
                      id: this.state.selectedPredefinedItem.id,
                      predefinedItemName: this.state.predefinedItemName,
                      amount: Number.parseFloat(this.state.predefinedItemAmount),
                      tax: Number.parseFloat(this.state.predefinedItemTax),
                      total: this.state.predefinedItemTotal,
                      description: this.state.predefinedItemDescription,
                      currency: this.state.predefinedItemCurrency
                    }
                  )
                    .then(res => {
                      switch (this.props.posState.statusCode) {
                        case 200:
                          this.setState(
                            (prevState: States, props: Props) =>
                              ({
                                predefinedItemLoading: false,
                                openAddPredefinedItemModal: false,
                                selectedPredefinedItem: this.props.posState.predefinedItems
                                  .find((p: PosRegistrationResponse) => p.name === prevState.predefinedItemName)
                              }),
                            () => {
                              this.setState((prevState: States, props: Props) =>
                                ({
                                  amount: addZeroCentIfNecessary(prevState.predefinedItemAmount, prevState.amountError),
                                  tax: addZeroCentIfNecessary(prevState.predefinedItemTax, prevState.taxError),
                                  total: prevState.predefinedItemTotal,
                                  description: prevState.predefinedItemDescription
                                })
                              );
                            }
                          );
                          break;
                        case 400:
                          break;
                        default:
                          break;
                      }
                    });
                } else {
                  this.props.createPredefinedItem(
                    {
                      predefinedItemName: this.state.predefinedItemName,
                      amount: Number.parseFloat(this.state.predefinedItemAmount),
                      tax: Number.parseFloat(this.state.predefinedItemTax),
                      total: this.state.predefinedItemTotal,
                      description: this.state.predefinedItemDescription,
                      currency: this.state.predefinedItemCurrency
                    }
                  )
                    .then(res => {
                      switch (this.props.posState.statusCode) {
                        case 200:
                          this.setState(
                            (prevState: States, props: Props) =>
                              ({
                                predefinedItemLoading: false,
                                openAddPredefinedItemModal: false,
                                selectedPredefinedItem: this.props.posState.predefinedItems
                                  .find((p: PosRegistrationResponse) => p.name === prevState.predefinedItemName)
                              }),
                            () => {
                              this.setState((prevState: States, props: Props) =>
                                ({
                                  amount: addZeroCentIfNecessary(prevState.predefinedItemAmount, prevState.amountError),
                                  tax: addZeroCentIfNecessary(prevState.predefinedItemTax, prevState.taxError),
                                  total: prevState.predefinedItemTotal,
                                  description: prevState.predefinedItemDescription
                                })
                              );
                            }
                          );
                          break;
                        case 400:
                          break;
                        default:
                          break;
                      }
                    });
                }
              });
          }}
        />
      );
    }
  }

  private predefinedItemErrorExists = (): boolean => {
    const {
      predefinedItemNameError,
      predefinedItemAmountError,
      predefinedItemTaxError,
      predefinedItemDescriptionError
    } = this.state;

    return predefinedItemNameError !== '' ||
      predefinedItemAmountError !== '' ||
      predefinedItemTaxError !== '' ||
      predefinedItemDescriptionError !== '';
  }

  private predefinedItemNotComplete = () => {
    const {
      predefinedItemName,
      predefinedItemAmount,
      predefinedItemDescription
    } = this.state;

    return predefinedItemName === '' ||
      predefinedItemAmount === '' ||
      predefinedItemDescription === '';
  }

  private mapPayerName = (props: Props): string[] => {
    return props.payersState.payers.map((p: PayerInfo) => p.firstName + ' ' + p.lastName + ', ' + p.mobile1);
  }

  private mapMemberName = (props: Props): string[] => {
    return props.membersState.members.map((p: Member) => p.firstName + ' ' + p.lastName + ', ' + p.mobile1);
  }

  private handleSearchTextPayerUpdate = (searchText: string): void =>
    this.setState({
      searchTextPayer: searchText
    })

  private handleSearchTextMemberUpdate = (searchText: string): void =>
    this.setState({
      searchTextMember: searchText
    })

  private handleNewRequestPayer = (chosenRequest: string, index: number): void => {
    var payer = this.filterPayer(chosenRequest);
    if (payer) {
      this.setState({
        selectedPayer: payer,
        email: payer.email ? payer.email : undefined,
        relatedMembers: this.filterMembers(payer.payingMembers)
      }, () => {
        this.props.getPayMethods(payer.id);
      });
    }
  }

  private handleNewRequestMember = (chosenRequest: string, index: number): void => {
    var member = this.filterMember(chosenRequest);
    if (member) {
      var payers = this.props.payersState.payers.filter((p: PayerInfo) => p.payingMembers.includes(member.id));
      this.setState({
        selectedMember: member,
        email: member.email ? member.email : undefined,
        relatedPayers: payers
      });
    }
  }

  private renderSelectedPayer = (): JSX.Element => {
    return (
      <Chip
        onRequestDelete={this.handleRequestDelete}
        labelStyle={{ height: 50, width: '100%', fontSize: 14 }}
        style={{ height: 50, width: '100%' }}
      >
        {
          this.state.selectedPayer && this.state.selectedPayer.firstName + ' ' + this.state.selectedPayer.lastName
        } /
        {
          this.state.selectedPayer && this.state.selectedPayer.mobile1
        }
      </Chip>
    );
  }

  private renderSelectedMember = (): JSX.Element => {
    return (
      <Chip
        onRequestDelete={this.handleRequestDelete}
        labelStyle={{ height: 50, width: '100%', fontSize: 14 }}
        style={{ height: 50, width: '100%' }}
      >
        <Avatar
          src={this.state.selectedMember && this.state.selectedMember.picUrl}
          style={{ height: 50, width: 50 }}
        />
        {
          this.state.selectedMember && this.state.selectedMember.firstName + ' ' + this.state.selectedMember.lastName
        } /
        {
          this.state.selectedMember && this.state.selectedMember.memberId
        }
      </Chip>
    );
  }

  private filterMembers = (memberIds: number[]): Member[] => {
    return this.props.membersState.members.filter((m: Member) =>
      memberIds.includes(m.id)
    );
  }
  private filterPayer = (nameAndPhone: string): PayerInfo => {
    return this.props.payersState.payers.filter((p: PayerInfo) =>
      p.firstName + ' ' + p.lastName + ', ' + p.mobile1 === nameAndPhone
    )[0];
  }

  private filterMember = (nameAndPhone: string): Member => {
    return this.props.membersState.members.filter((m: Member) =>
      m.firstName + ' ' + m.lastName + ', ' + m.mobile1 === nameAndPhone
    )[0];
  }

  private handleRequestDelete = (): void =>
    this.setState({
      selectedPayer: undefined,
      selectedPayMethod: undefined,
      cardHolderName: '',
      creditNumber: '',
      expiryMonth: '',
      expiryYear: '',
      cvc: '',
      selectedMember: undefined,
      email: '',
      searchTextPayer: ''
    })

  private getDefaultTax = (): number => {
    const businessProvince = this.props.businessState.business && this.props.businessState.business.province;
    const list = ProvincialTaxes.filter((p: ProvincialTax) => p.province === businessProvince);

    return list.length >= 1 ? list[0].tax : 0;
  }

  private onCurrencyChange = (e: React.SyntheticEvent<{}>, index: number, value: Currency): void =>
    this.setState({ currency: value })

  private onPredefinedItemCurrencyChange = (e: React.SyntheticEvent<{}>, index: number, value: Currency): void =>
    this.setState({ predefinedItemCurrency: value })

  private onSelectedPayMethodChange = (
    e: React.SyntheticEvent<{}>,
    index: number,
    value: PayMethodsInfo
  ): void => {
    this.setState({
      selectedPayMethod: value,
      cardHolderName: value.cardHolderName,
      creditNumber: value.cardNumber,
      expiryMonth: value.expiryMonth,
      expiryYear: value.expiryYear
    });
  }

  private onSelectedPayerChange = (
    e: React.SyntheticEvent<{}>,
    index: number,
    value: PayerInfo
  ): void => {
    this.props.getPayMethods(value.id).then(
      response => {
        switch (this.props.payMethodsState.statusCode) {
          case 200:
            return this.setState({
              selectedPayer: value,
              paymethods: this.props.payMethodsState.payMethods
            });
          default:
        }
      }
    );
  }

  private onSelectedMemberChange = (
    e: React.SyntheticEvent<{}>,
    index: number,
    value: Member
  ): void => {
    this.setState({
      selectedMember: value
    });
  }

  private onSelectedPredefinedItemChange = (
    e: React.SyntheticEvent<{}>,
    index: number,
    value: PosRegistrationResponse
  ): void => this.setState(
    { selectedPredefinedItem: value },
    () => {
      this.setState((prevState: States, props: Props) =>
        ({
          amount: addZeroCentIfNecessary(prevState.selectedPredefinedItem.amount.toString(), prevState.amountError),
          tax: addZeroCentIfNecessary(
            prevState.selectedPredefinedItem.tax.toString(),
            prevState.taxError
          ),
          total: prevState.selectedPredefinedItem.total,
          description: prevState.selectedPredefinedItem.description
        })
      );
    }
  )

  private onPaymentTypeChange = (e: React.SyntheticEvent<{}>, index: number, value: PaymentMethodType): void =>
    this.setState({ paymentMethodType: value })

  private renderServiceAgreementLink = (text: String): JSX.Element => {
    return (
      <Link
        to="/service-agreement"
      >
        {text}
      </Link>
    );
  }

  private renderLoadingSpinnerOrSubmitButton = (): JSX.Element => {
    if (this.state.loading) {
      return (
        <RefreshIndicator
          size={40}
          left={10}
          top={0}
          status="loading"
          style={{
            display: 'inline-block',
            position: 'relative',
          }}
        />
      );
    } else {
      return (
        <RaisedButton
          label={this.notEnoughPermission() ? 'Not Enough Permission' : 'Submit'}
          primary={true}
          onClick={this.registerPosSale}
          disabled={this.errorExists() || this.notEnoughPermission()}
        />
      );
    }
  }

  private notEnoughPermission = (): boolean => {
    return !(
      isPosCreate(this.props.authState, this.props.adminState) ||
      isPosFull(this.props.authState, this.props.adminState)
    );
  }

  private errorExists = (): boolean => {
    if (this.state.paymentMethodType === 'CREDITCARD') {
      return this.state.amountError !== '' || this.state.cardHolderNameError !== '' ||
        this.state.creditNumberError !== '' || this.state.expiryError !== '' || this.isCreditCardFieldEmpty();
    } else if (this.state.paymentMethodType === 'CASH') {
      return this.state.amountError !== '' || this.isCashFieldEmpty();
    } else {
      return false;
    }
  }

  private isCreditCardFieldEmpty = (): boolean => {
    return this.state.amount === '' || this.state.cardHolderName === '' ||
      this.state.creditNumber === '' ||
      (this.state.selectedPayMethod !== undefined ? false : this.state.cvc === '') ||
      this.state.expiryMonth === '' ||
      this.state.expiryYear === '' || this.state.description === '';
  }

  private isCashFieldEmpty = (): boolean => {
    return this.state.amount === '' || this.state.description === '';
  }

  private registerPosSale = (): void => {
    this.setState(
      { loading: !isAuthTokenExpired() },
      () => this.props.registerPos(
        {
          cardNumber: this.state.paymentMethodType === 'CREDITCARD' ? this.state.creditNumber : undefined,
          cardHolderName: this.state.paymentMethodType === 'CREDITCARD' ? this.state.cardHolderName : undefined,
          cvc: this.state.paymentMethodType === 'CREDITCARD' ? this.state.cvc : undefined,
          expiryMonth: this.state.paymentMethodType === 'CREDITCARD' ? this.state.expiryMonth : undefined,
          expiryYear: this.state.paymentMethodType === 'CREDITCARD' ? this.state.expiryYear : undefined,
          amount: Number.parseFloat(this.state.amount),
          description: this.state.description,
          currency: this.state.currency,
          email: this.state.email,
          tax: Number.parseFloat(this.state.tax),
          total: this.state.total,
          id: this.state.selectedMember && this.state.selectedMember.id,
          paymentMethodType: this.state.paymentMethodType,
          payMethodId: this.state.selectedPayMethod ? this.state.selectedPayMethod.id : undefined
        }
      )
    );
  }

  private handleDescriptionChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({ description: newValue })

  private handlePredefinedItemDescriptionChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({
      predefinedItemDescription: newValue,
      predefinedItemDescriptionError: newValue.length > MAX_LENGTH ? 'Too long' : ''
    })

  private handleEmailChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({
      email: newValue,
      emailError: validator.isEmail(newValue) ? '' : 'Enter a valid email'
    })

  private handlePredefinedItemNameChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({
      predefinedItemName: newValue,
      predefinedItemNameError: isValidBusinessName(newValue) ?
        this.props.posState.predefinedItems
          .map((p: PosRegistrationResponse) => p.name.trim().toLowerCase())
          .includes(newValue.trim().toLowerCase()) ?
          'Item already exists' :
          '' :
        'Enter a valid item name'
    })

  private handleAmountChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void => {
    const formatted = newValue.trim();

    this.setState(
      {
        amount: formatted,
        amountError: !isValidAmount(formatted) ? 'Please enter a valid amount' : ''
      },
      () => {
        this.setState(
          {
            tax: this.calculateTax(),
            total: parseFloat((parseFloat(formatted) + parseFloat(this.calculateTax())).toFixed(2)),
          }
        );
      }
    );
  }

  private handlePredefinedItemAmountChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void => {
    const formatted = newValue.trim();

    this.setState(
      {
        predefinedItemAmount: formatted,
        predefinedItemAmountError: !isValidAmount(formatted) ? 'Please enter a valid amount' : ''
      },
      () => {
        this.setState(
          {
            predefinedItemTax: this.calculatePredefinedTax(),
            predefinedItemTotal:
              parseFloat((parseFloat(formatted) + parseFloat(this.calculatePredefinedTax())).toFixed(2)),
          }
        );
      }
    );
  }

  private calculatePredefinedTax = (): string => {
    return isValidAmount(this.state.predefinedItemAmount) ?
      (parseFloat(this.state.predefinedItemAmount) / 100 * this.state.taxPercentage).toFixed(2) :
      '0.00';
  }

  private calculateTax = (): string => {
    return isValidAmount(this.state.amount) ?
      (parseFloat(this.state.amount) / 100 * this.state.taxPercentage).toFixed(2) :
      '0.00';
  }

  private handleTaxChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void => {
    const formatted = newValue.trim();

    this.setState(
      {
        tax: formatted,
        taxError: !isValidAmount(formatted) ? 'Please enter a valid tax' : ''
      },
      () => {
        this.setState((prevState: States, props: Props) => ({
          total: parseFloat((parseFloat(prevState.tax) + parseFloat(prevState.amount)).toFixed(2))
        }));
      }
    );
  }

  private handlePredefinedItemTaxChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void => {
    const formatted = newValue.trim();

    this.setState(
      {
        predefinedItemTax: formatted,
        predefinedItemTaxError: !isValidAmount(formatted) ? 'Please enter a valid tax' : ''
      },
      () => {
        this.setState((prevState: States, props: Props) => ({
          predefinedItemTotal: parseFloat(
            (parseFloat(prevState.predefinedItemTax) + parseFloat(prevState.predefinedItemAmount)).toFixed(2)
          )
        }));
      }
    );
  }

  private handleCvcChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({
      cvc: newValue
    })

  private handleCardHolderNameChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({
      cardHolderName: newValue,
      cardHolderNameError: isValidName(newValue) ? '' : 'Enter valid name'
    })

  private handleCreditNumberChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void => {
    this.setState({
      creditNumber: newValue,
      creditNumberError: (
        (newValue.length === CREDIT_CARD_LENGTH && newValue.charAt(0) !== '3') ||
        (newValue.length === AMEX_LENGTH && newValue.charAt(0) === '3')) &&
        validateCreditCardNumber(newValue) ?
        '' :
        'Enter valid creditcard number',
      creditcardType: (
        (newValue.length === CREDIT_CARD_LENGTH && newValue.charAt(0) !== '3') ||
        (newValue.length === AMEX_LENGTH && newValue.charAt(0) === '3')) &&
        validateCreditCardNumber(newValue) ?
        parseCreditCardType(newValue) :
        NONE
    });
  }

  private handleExpiryMonthChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({
      expiryMonth: newValue,
      expiryError: creditcardutils.validateCardExpiry(newValue, this.state.expiryYear) &&
        newValue.length === 2 ? '' : 'Enter valid expiry'
    })

  private handleExpiryYearChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({
      expiryYear: newValue,
      expiryError: creditcardutils.validateCardExpiry(this.state.expiryMonth, newValue) &&
        newValue.length === 2 ? '' : 'Enter valid expiry'
    })
}

export default PosSaleComponent;



// WEBPACK FOOTER //
// ./src/pos/PosSaleComponent.tsx